<template>
	<div class="face-callback-container">
		<div class="callback-content">
			<div class="success-icon">
				<i class="el-icon-success" style="font-size: 80px; color: #67c23a;"></i>
			</div>
			<div class="success-text">
				二维码扫描成功
			</div>
			<div class="tip-text" v-if="showCloseButton">
				请手动关闭此页面
			</div>
			<div class="close-button-container" v-if="showCloseButton">
				<el-button type="primary" @click="handleClose">关闭窗口</el-button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FaceCallback',
	data() {
		return {
			showCloseButton: false
		}
	},
	mounted() {
		setTimeout(() => {
			this.autoClose();
		}, 1000);
		
		setTimeout(() => {
			this.showCloseButton = true;
		}, 2000);
	},
	methods: {
		autoClose() {
			try {
				window.close();
				setTimeout(() => {
					if (!document.hidden) {
						this.showCloseButton = true;
					}
				}, 500);
			} catch (e) {
				this.showCloseButton = true;
			}
		},
		handleClose() {
			try {
				window.close();
			} catch (e) {
				this.$message({
					message: '请手动关闭此页面',
					type: 'info',
					duration: 2000
				});
			}
		}
	}
}
</script>

<style scoped>
.face-callback-container {
	display: flex;
	justify-content: center;
	align-items: center;
	min-height: 100vh;
	background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
	padding: 20px;
}

.callback-content {
	text-align: center;
	background: white;
	border-radius: 16px;
	padding: 60px 40px;
	box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
	max-width: 400px;
	width: 100%;
	animation: fadeInUp 0.5s ease-out;
}

@keyframes fadeInUp {
	from {
		opacity: 0;
		transform: translateY(20px);
	}
	to {
		opacity: 1;
		transform: translateY(0);
	}
}

.success-icon {
	margin-bottom: 30px;
	display: flex;
	justify-content: center;
	animation: scaleIn 0.5s ease-out;
}

@keyframes scaleIn {
	from {
		opacity: 0;
		transform: scale(0.5);
	}
	to {
		opacity: 1;
		transform: scale(1);
	}
}

.success-text {
	font-size: 20px;
	color: #333;
	font-weight: 600;
	line-height: 1.6;
	margin-bottom: 15px;
}

.tip-text {
	font-size: 14px;
	color: #999;
	margin-bottom: 20px;
}

.close-button-container {
	display: flex;
	justify-content: center;
}
</style>

